import { render, staticRenderFns } from "./CatalogueCotizaciones.vue?vue&type=template&id=1f71d33b&scoped=true&"
import script from "./CatalogueCotizaciones.vue?vue&type=script&lang=js&"
export * from "./CatalogueCotizaciones.vue?vue&type=script&lang=js&"
import style0 from "./CatalogueCotizaciones.vue?vue&type=style&index=0&id=1f71d33b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f71d33b",
  null
  
)

export default component.exports